import api from '..'

const requests = {
    fetchGenres: async ({ search, sortKey, sortType, pageSize, page }) => {
        var response = await api.get(`/wellful/Genre/`, {
            params: {
                search,
                sortKey,
                sortType,
                pageSize,
                page
            }
        })

        return response.data
    },
    fetchGenre: async (id) => {
        try {
            var response = await api.get(`/wellful/Genre/${id}`)
            return response.data
        } catch (error) {
            throw error.response ? error.response.status : error
        }
    },
    createGenre: async (payload) => {
        var response = await api.post(`/wellful/Genre`, payload)
        return response.data
    },
    updateGenre: async (payload) => {
        var response = await api.put(`/wellful/Genre/${payload.id}`, payload)
        return response.data
    },
    updateHeaderImage: async (id, payload) => {
        var formData = new FormData()

        formData.append('file', payload.file)

        return api.put(`/wellful/Genre/${id}/HeaderImage`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },
    updateBackgroundImage: async (id, payload) => {
        var formData = new FormData()

        formData.append('file', payload.file)

        return api.put(`/wellful/Genre/${id}/BackgroundImage`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },

    updatePlayerGraphicImage: async (id, payload) => {
        var formData = new FormData()

        formData.append('file', payload.file)

        return api.put(`/wellful/Genre/${id}/PlayerGraphicImage`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },

    fetchGenreListNumbers: async (id) => {
        try {
            var response = await api.get(`/wellful/Genre/${id}/SortOrders`)
            return response.data
        } catch (error) {
            throw error.response ? error.response.status : error
        }
    },
    setReady: async (payload) => {
        var response = await api.put(`/wellful/Genre/${payload.id}/Ready`, payload)
        return response.data
    }
}

export default requests
